const header = document.querySelector('header.main-header');
const navItems = document.querySelectorAll('#nav li.nav-item'); 
const amsLogo = document.querySelectorAll('header .logo-container g g:first-child path');
const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');


// Set initial product header color immediately
if (header.classList.contains('product-header')) {    
    amsLogo.forEach(item => {
        item.style.fill = '#283343';
    });
}

dropdownTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
        const content = trigger.nextElementSibling;
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
        // Toggle the dropdown
        trigger.setAttribute('aria-expanded', !isExpanded);
        content.classList.toggle('active');
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        if (!trigger.contains(e.target)) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.nextElementSibling.classList.remove('active');
        }
    });
});

const updateHeaderStyles = (isScrolled) => {
    const action = isScrolled ? 'add' : 'remove';
    header.classList[action]('scrolled-header');
    navItems.forEach(item => {
        item.classList[action]('white-bg');
    });
    
    if (header.classList.contains('product-header')) {
        // Always set to #283343 for product headers
        amsLogo.forEach(item => {
            item.style.fill = '#283343';
        });
    } else {
        // Never use white fill if we've scrolled down
        if (window.scrollY > 50) {
            amsLogo.forEach(item => {
                item.style.fill = '#283343';
                // Add !important to override any hover styles
                item.style.setProperty('fill', '#283343', 'important');
            });
        } else {
            amsLogo.forEach(item => {
                item.style.fill = '#FFF';
            });
        }
    }
};

// Update scroll event listener
window.addEventListener('scroll', () => {
    // Don't update styles on error404 pages
    if (!document.body.classList.contains('error404')) {
        updateHeaderStyles(window.scrollY > 50);
    }
});

if (document.body.classList.contains('error404')) { 
    updateHeaderStyles(true); // Set to true to add the classes instead of removing them
}
